// extracted by mini-css-extract-plugin
export default {"confirmWrap":"confirmation_confirmWrap__X1zm3","nextSteps":"confirmation_nextSteps__lF5si"};